import Service from '@ember/service';

import type { AnnotationData } from 'webapp/models-custom/annotation';
import type Annotation from 'webapp/models-custom/annotation';
import type SampleRecord from 'webapp/models/sample';

export default class AnnotationsService extends Service {
	updateSampleAnnotations(
		sample: SampleRecord,
		id: number | null,
		model: Annotation | null,
	): void {
		const isCreate = !!model && !id;
		const isUpdate = !!model && !!id;
		const isDelete = !model;

		let annotations: AnnotationData[] = sample.sampledata.annotations || [];

		if (isCreate) {
			const data = model.toJSON();
			annotations.push(data);
		} else if (isUpdate) {
			const data = model.toJSON();
			const annotation = annotations.find((a) => a.id === id);
			if (annotation) {
				annotation.timestamp = data.timestamp;
				annotation.note = data.note;
				annotation.metricSetup = data.metricSetup;
			}
		} else if (isDelete) {
			annotations = annotations.filter((a) => a.id !== id);
		}

		sample.sampledata.annotations = annotations;
		sample.sampledata = Object.assign({}, sample.sampledata);
	}
}

declare module '@ember/service' {
	interface Registry {
		annotations: AnnotationsService;
	}
}
